export const original = "an-original";



// WEBPACK FOOTER //
// ./src/mod3.js